import React, { Fragment } from "react";
import styled from "styled-components";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import { isValidLink } from "@lifeat/shared/util/StringUtil";
import { FontSize } from "@themes/Fonts";
import { isExternalLink } from "@util/BrowserUtil";
import { buildRoute } from "@util/RouteUtil";

const Text = styled.div`
    font-size: ${FontSize.normal};
    color: ${(props) => props.theme.textColorPrimary};
    word-break: break-word;
    white-space: pre-wrap;
`;

const TextLink = styled.a`
    color: ${(props) => props.theme.textColorPrimary};
`;

interface LifeAtTextBlockFormattedProps {
    readonly text: string;
    readonly highlightLinks: boolean;
    readonly className?: string;
}
export default function LifeAtTextBlockFormatted(props: LifeAtTextBlockFormattedProps) {
    const messageContent = tokenizeIncludingWhitespaces(props.text).map((substr, i) => {
        if (isValidLink(substr)) {
            const href = isExternalLink(substr) ? linkToRedirectPage(substr) : substr;
            return (
                <TextLink key={i} href={href} target="_blank" rel="noopener noreferrer">
                    {substr}
                </TextLink>
            );
        } else {
            return <Fragment key={i}>{substr}</Fragment>;
        }
    });

    return <Text className={props.className}>{props.highlightLinks ? messageContent : props.text}</Text>;
}

function linkToRedirectPage(link: string) {
    return buildRoute(Routes.ExternalRedirect) + "?" + new URLSearchParams({ url: link });
}

function tokenizeIncludingWhitespaces(text: string): string[] {
    return text.split(/(\s+)/).filter((token) => token !== "");
}
